import { createSelector } from '@ngrx/store';
import { DateTime } from 'luxon';

import { Comparer, filterQuickSearch } from '@common/services/utils.service';

import { ImageCopy } from '../domain/models';
import { getBckpState, IBckpState } from './bckp.reducer';
import * as fromCopiesReducer from './copies/copies.reducer';
import { IBckpCopiesEvolState } from './copies/evol/evol.reducer';
import { BckpConstants } from '../bckp.constants';

// #region Current Copies
const getBckpCopiesCurrState = createSelector(
    getBckpState,
    (state: IBckpState) =>
        state[fromCopiesReducer.BckpCopiesFeatureKey][fromCopiesReducer.BckpCopiesCurrFeatureKey]
);
const getCopiesCurrCollection = createSelector(
    getBckpCopiesCurrState,
    (state) =>
        state.copies
);
export const {
    selectAll: getAllCopiesCurr
} = fromCopiesReducer.copiesCurrAdapter.getSelectors(getCopiesCurrCollection);
export const getCopiesCurrQueryString = createSelector(
    getBckpCopiesCurrState,
    (state) =>
        state.odata.qs
);
export const getCopiesCurrIsDataValid = createSelector(
    getBckpCopiesCurrState,
    (state) =>
        state.expirationDate !== null && DateTime.utc() < state.expirationDate
);
export const getCopiesCurrIsEmpty = createSelector(
    getBckpCopiesCurrState,
    (state) =>
        state.isEmpty
);
export const getCopiesCurrIsLoaded = createSelector(
    getBckpCopiesCurrState,
    (state) =>
        state.isLoaded
);
export const getCopiesCurrIsLoading = createSelector(
    getBckpCopiesCurrState,
    (state) =>
        state.isLoading
);
export const getCopiesCurrIsOups = createSelector(
    getBckpCopiesCurrState,
    (state) =>
        state.isOups
);
export const getBckpCopiesCurrFilter = createSelector(
    getBckpCopiesCurrState,
    (state) =>
        state.odata.filter
);
export const getQuickSearchedCopiesCurr = createSelector(
    getBckpCopiesCurrState,
    getAllCopiesCurr,
    (state: fromCopiesReducer.IBckpCopiesCurrState, copies: ImageCopy[]) =>
        filterQuickSearch(copies, state.qsWord, BckpConstants.copiesQSFields)
);
export const getPipelinedCopiesCurr = createSelector(
    getQuickSearchedCopiesCurr,
    (copies: ImageCopy[], params: { comparer: Comparer<ImageCopy> }) =>
        [...copies].sort(params.comparer)
);
// #endregion

// #region Evolution Copies
const getBckpCopiesEvolState = createSelector(
    getBckpState,
    (state: IBckpState) =>
        state[fromCopiesReducer.BckpCopiesFeatureKey][fromCopiesReducer.BckpCopiesEvolFeatureKey]
);
const getCopiesEvolCollection = createSelector(
    getBckpCopiesEvolState,
    (state: IBckpCopiesEvolState) =>
        state.copies
);
export const {
    selectAll: getAllCopiesEvol
} = fromCopiesReducer.evolCopiesAdapter.getSelectors(getCopiesEvolCollection);
export const getCopiesEvolQueryString = createSelector(
    getBckpCopiesEvolState,
    (state: IBckpCopiesEvolState) =>
        state.odata.qs
);
export const getCopiesEvolIsDataValid = createSelector(
    getBckpCopiesEvolState,
    (state: IBckpCopiesEvolState) =>
        state.expirationDate !== null && DateTime.utc() < state.expirationDate
);
export const getCopiesEvolIsLoading = createSelector(
    getBckpCopiesEvolState,
    (state: IBckpCopiesEvolState) =>
        state.isLoading
);
export const getCopiesEvolIsOups = createSelector(
    getBckpCopiesEvolState,
    (state: IBckpCopiesEvolState) =>
        state.isOups
);
export const getCopiesEvolIsLoaded = createSelector(
    getBckpCopiesEvolState,
    (state: IBckpCopiesEvolState) =>
        state.isLoaded
);
export const getBckpCopiesEvolFilter = createSelector(
    getBckpCopiesEvolState,
    (state) =>
        state.odata.filter
);
export const getCopiesEvolIsEmpty = createSelector(
    getBckpCopiesEvolState,
    (state) =>
        state.isEmpty
);
// #endregion
